import { render, staticRenderFns } from "./product-availability-stores.vue?vue&type=template&id=5123e395&"
import script from "./product-availability-stores.vue?vue&type=script&lang=ts&"
export * from "./product-availability-stores.vue?vue&type=script&lang=ts&"
import style0 from "../../assets/scss/spacer.scss?vue&type=style&index=0&lang=scss&module=styleSpacer&"
import style1 from "./product-availability-stores.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["styleSpacer"] = (style0.locals || style0)
this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports